<script setup lang="ts">
type SwitchOption = 'left' | 'right';
export type ToggleSwitchItem = {
  leftLabelName: string;
  rightLabelName: string;
  activeOption: SwitchOption;
};

const props = defineProps<{ toggleSwitchItem: ToggleSwitchItem }>();
const emit = defineEmits<{ toggleSwitch: [] }>();
let previousOption: SwitchOption | undefined = undefined; // 前に選択したoption.初期値はundefined

const toggleSwitch = () => {
  if (previousOption !== props.toggleSwitchItem.activeOption) {
    previousOption = props.toggleSwitchItem.activeOption;
    emit('toggleSwitch');
  }
};
</script>

<template>
  <div class="toggle" @click="toggleSwitch">
    <div
      class="left"
      :class="{ active: toggleSwitchItem.activeOption === 'left' }"
    >
      {{ toggleSwitchItem.leftLabelName }}
    </div>
    <div
      class="right"
      :class="{ active: toggleSwitchItem.activeOption === 'right' }"
    >
      {{ toggleSwitchItem.rightLabelName }}
    </div>
  </div>
</template>

<style scoped lang="scss">
.toggle {
  display: flex;
  background: $color-gray400;
  border-radius: 5px;
  font-size: 12px;
  line-height: 16px;
  color: $color-gray1000;
  cursor: pointer;
  > * {
    width: 50%;
    padding: 4px 0;
    border-radius: 4px;
    margin: 1px;
    text-align: center;
  }
  .active {
    background: #fff;
  }
}
</style>
